export default "__VITE_ASSET__CN2Yf3jw__"